export default __webpack_public_path__ + "static/media/hip.ebf6c9da.png";